import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = { current: String }

  switch(event) {
    // Let the link navigate naturally — server handles view switch and session persistence
  }
}
